import { render, staticRenderFns } from "./QueueForm.vue?vue&type=template&id=6e513735&scoped=true&"
import script from "./QueueForm.vue?vue&type=script&lang=ts&"
export * from "./QueueForm.vue?vue&type=script&lang=ts&"
import style0 from "./QueueForm.vue?vue&type=style&index=0&id=6e513735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e513735",
  null
  
)

export default component.exports